import React, { useEffect } from "react";
import {
  Navigate,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { checkAuthAndRedirect } from "../../../utils/auth";
import TestAssignStudentsPanel from "./TestAssignStudentsPanel";
import TestPageShell from "./TestPageShell";
import {
  resolveAssignTest,
  type AssignStudentsLocationState,
} from "./testRouteUtils";
import { decodeTestNameFromPath, useTestRoutes } from "./testRoutes";

const TestAssignStudents: React.FC = () => {
  const { testName: testNameParam } = useParams<{ testName: string }>();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const locationState = location.state as AssignStudentsLocationState | null;
  const stateTest = locationState?.test;
  const batchContext = locationState?.batchContext;
  const batchConfigs = locationState?.batchConfigs;
  const subjects = locationState?.subjects;
  const routeTestName = decodeTestNameFromPath(testNameParam);
  const testId = searchParams.get("test_id") ?? undefined;
  const batchId = searchParams.get("batch_id") ?? undefined;
  const courseId = searchParams.get("course_id") ?? undefined;
  const slotIdParam = searchParams.get("slot_id");
  const slotId =
    locationState?.slot_id ??
    (slotIdParam != null && slotIdParam !== ""
      ? Number(slotIdParam)
      : undefined);

  const routes = useTestRoutes();

  useEffect(() => {
    checkAuthAndRedirect();
  }, []);

  const test = resolveAssignTest(testId, stateTest);

  if (!routeTestName || !testId || !test || test.test_id !== testId) {
    return <Navigate to={routes.configure} replace />;
  }

  const matchingBatchConfig = batchConfigs?.find((b) => b.batch_id === batchId);

  const resolvedBatchContext =
    batchContext &&
    batchContext.batch_id === (batchId ?? batchContext.batch_id)
      ? {
          ...batchContext,
          course_id:
            batchContext.course_id ||
            matchingBatchConfig?.course_id ||
            courseId ||
            "",
          course_name:
            batchContext.course_name ||
            matchingBatchConfig?.course_name ||
            "",
        }
      : batchId
        ? {
            track_id:
              searchParams.get("track_id") ??
              matchingBatchConfig?.track_id ??
              "",
            track_name: matchingBatchConfig?.track_name ?? "",
            course_id:
              courseId ?? matchingBatchConfig?.course_id ?? "",
            course_name: matchingBatchConfig?.course_name ?? "",
            batch_id: batchId,
            batch_name: matchingBatchConfig?.batch_name ?? "",
          }
        : undefined;

  return (
    <TestPageShell showCardSearch={false}>
      <TestAssignStudentsPanel
        test={test}
        batchContext={resolvedBatchContext}
        batchConfigs={batchConfigs}
        subjects={subjects}
        slotId={Number.isFinite(slotId) ? slotId : undefined}
      />
    </TestPageShell>
  );
};

export default TestAssignStudents;
